import { createContext } from 'react';

import type { WorkflowDateFormat } from '@/api/workflows';

import { DATE_INPUT_FORMAT } from './fieldValidation';

/**
 * The workflow's date format (QA D-01) for the Date controls below FormShell — the picker's
 * display and typed format, its placeholder, and the typed-date check at blur. FormShell provides
 * it from `template.dateFormat`.
 *
 * A context rather than a prop for the same reason as `ClientLanguageContext`: borrowed reveal
 * fields and repeatable instances hear it without every renderer in between threading it
 * through. No provider (the builder canvas and other stand-alone renderers) = the default
 * DD/MM/YYYY, which is what every form showed before the setting existed.
 */
export const DateFormatContext = createContext<WorkflowDateFormat>(DATE_INPUT_FORMAT);

/** The effective format of a workflow: its own, or the default when unset. */
export function resolveDateFormat(
  format: WorkflowDateFormat | null | undefined,
): WorkflowDateFormat {
  return format ?? DATE_INPUT_FORMAT;
}

/** The format as a French reader writes it — "MM/JJ/AAAA" (jour, année) — for the PLACEHOLDER only; the
 *  picker still parses the workflow's own tokens (QA RIF TC-07-12: the French page showed "MM/DD/YYYY"). */
export function formatPlaceholder(format: string, language: 'en' | 'fr'): string {
  return language === 'fr' ? format.replace(/D/g, 'J').replace(/Y/g, 'A') : format;
}
